import { CommonResponse, get } from './common.ts'

// GET /project/list
interface GetProjectListResponse {
  projects: {
    id: string
    name: string
    description: string
    client: string
    img: string
    imgHeight: number
  }[]
}

export const getProjectList = async (): Promise<CommonResponse<GetProjectListResponse>> => {
  return await get('/project/list')
}

// GET /project/detail
interface GetProjectDetailResponse {
  project: {
    name: string
    description: string
    client: string
    link?: string
    topImg?: string
    bottomImg?: string
    projectType: string
    projectDescription: string
    projectDuration: string
  }
}

export const getProjectDetail = async (
  id: string
): Promise<CommonResponse<GetProjectDetailResponse>> => {
  return await get(`/project/detail/${id}`)
}
